<div class="p-12 br-8" :style="{ background: '#F8F8F8'}"><slot name="body"></slot></div>